const getDeploymentBase = () => {
  const publicUrl = process.env.PUBLIC_URL;
  if (publicUrl && publicUrl !== ".") {
    return publicUrl.replace(/\/$/, "");
  }

  if (typeof document === "undefined") return "";

  const bundleScript = Array.from(document.scripts).find((script) =>
    /\/static\/js\/[^/]+\.js(?:\?.*)?$/.test(script.src)
  );

  return bundleScript
    ? new URL("../../", bundleScript.src).pathname.replace(/\/$/, "")
    : "";
};

export const resolveAssetPath = (path) => {
  if (!path) return path;
  if (path.startsWith("/assets/")) {
    return `${getDeploymentBase()}${path}`;
  }
  return path;
};
